import { UserRoles, UserRolesTypes } from '../../types/userRoles.ts';
import AccountLayout from '../../components/layouts/AccountLayout.tsx';
import AccountMenuItemButton from '../../components/account/settings/AccountMenuItemButton.tsx';
import { Cog8ToothIcon } from '@heroicons/react/24/solid';
import {
    ArrowRightStartOnRectangleIcon,
    Cog6ToothIcon,
    FilmIcon,
    KeyIcon,
    PresentationChartLineIcon,
    TrophyIcon,
    TvIcon,
    UserIcon,
} from '@heroicons/react/24/outline';
import { useAuth } from '../../hooks/useAuth.tsx';
import React from 'react';
import { useAppSelector } from '../../stores/store.ts';
import { selectCurrentUser } from '../../components/auth/authSelectors.ts';

const accountMenuItems: {
    link: string,
    title: string,
    icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>,
    permissionRoles?: UserRolesTypes[]
}[] = [
    { title: 'Konto', link: '/ustawienia/konto', icon: UserIcon },
    // { title: 'Zmiana hasła', link: '/ustawienia/zmiana-hasla' },
    { title: 'Odtwarzacz', link: '/ustawienia/odtwarzacz', icon: TvIcon },
    ...(import.meta.env.VITE_BACKEND_TYPE === 'php' ? [{
        title: 'Nagrania',
        link: '/konto/nagrania',
        icon: FilmIcon,
    },
        {
            title: 'Zarządzanie konkursami',
            link: '/ustawienia/konkursy',
            permissionRoles: [UserRoles.ADMINISTRATOR, UserRoles.MARKETING],
            icon: TrophyIcon,
        },
    ] : []),
    {
        title: 'Zarządzanie banerami',
        link: '/ustawienia/banery',
        permissionRoles: [UserRoles.ADMINISTRATOR, UserRoles.MARKETING],
        icon: PresentationChartLineIcon,
    },
    {
        title: 'Zarządzanie uprawnieniami',
        link: '/ustawienia/uprawnienia',
        permissionRoles: [UserRoles.ADMINISTRATOR],
        icon: KeyIcon,
    },
    {
        title: 'Panel administracyjny',
        link: '/ustawienia/panel-administracyjny',
        permissionRoles: [UserRoles.ADMINISTRATOR],
        icon: Cog6ToothIcon,
    },
];
export const AccountMenuPage = () => {
    const _authService = useAuth();
    const _currentUser = useAppSelector(selectCurrentUser);

    return (
        <AccountLayout>
            <h1 className={'text-4xl font-semibold'}>Ustawienia</h1>
            <div
                className="grid grid-cols-2 gap-2 sm:grid-cols-2 lg:grid-cols-3 lg:gap-3 xl:grid-cols-4 2xl:grid-cols-5 flex-wrap mt-5 items-stretch">
                {accountMenuItems.map((item) =>
                    (!item.permissionRoles ||
                        (_authService.user && item.permissionRoles?.some(role => _authService.user?.roles.some(x => x.toLowerCase() === role.toLowerCase())) || _currentUser && item.permissionRoles?.some(role => _currentUser?.roles.some(x => x.toLowerCase() === role.toLowerCase()))))
                    &&
                    <AccountMenuItemButton key={item.link} icon={item.icon ?? Cog8ToothIcon} label={item.title}
                                           link={item.link} />,
                )}
                <AccountMenuItemButton icon={ArrowRightStartOnRectangleIcon} label={'Wyloguj'} variant={'secondary'}
                                       onClick={() => _authService.logout()} />
            </div>
        </AccountLayout>
    );
};